<template>
  <!-- Líniové ikony výhod (štýl ako druzstevne/*.svg). Farba cez CSS `color`,
       hrúbka čiary je v px obrazovky (non-scaling-stroke), takže ikona vyzerá
       rovnako v 20px tabuľke aj v 90px sekcii výhod. -->
  <svg class="benefit-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor"
       :stroke-width="stroke" stroke-linecap="round" stroke-linejoin="round"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">

    <!-- návrh interiéru a zľava na nábytok: sedačka + % -->
    <g v-if="name === 'nabytok'">
      <path d="M11 28V23q0-4 4-4h20q4 0 4 4v5"/>
      <path d="M6 44V32q0-4 4-4t4 4v4h22v-4q0-4 4-4t4 4v12z"/>
      <path d="M10 44v4M40 44v4"/>
      <circle cx="50" cy="21" r="3"/>
      <circle cx="58" cy="33" r="3"/>
      <path d="M59 18L49 36"/>
    </g>

    <!-- skolaudovaný projekt: dom s iskrami -->
    <g v-else-if="name === 'skolaudovany'">
      <path d="M10 34L30 18l20 16"/>
      <path d="M15 30v20h30V30"/>
      <path d="M25 50V39h10v11"/>
      <path d="M50 4q0 7 7 7q-7 0-7 7q0-7-7-7q7 0 7-7z"/>
      <path d="M59 20q0 3.5 3.5 3.5Q59 23.5 59 27q0-3.5-3.5-3.5Q59 23.5 59 20z"/>
      <path d="M14 10q0 3.5 3.5 3.5Q14 13.5 14 17q0-3.5-3.5-3.5Q14 13.5 14 10z"/>
    </g>

    <!-- exteriérové žalúzie v cene bytu: kastlík, lamely, šnúra s očkom (podľa náčrtu klienta) -->
    <g v-else-if="name === 'zaluzie'">
      <rect x="9" y="9" width="46" height="6" rx="1"/>
      <path d="M13 21h36M13 26.5h36M13 32h36M13 37.5h36M13 43h36"/>
      <path d="M53 15v31"/>
      <ellipse cx="53" cy="50" rx="2.2" ry="3.5"/>
    </g>

    <!-- dispozícia s podielom: tvary 1:1 z druzstevne/dispozicia_podielom.svg (viewBox 420), zmenšené do 64 -->
    <g v-else-if="name === 'dispozicia'" transform="translate(-16.4 -17.2) scale(0.233)">
      <polyline points="180.21 279.46 139.94 241.71 99.67 279.46"/>
      <polyline points="170.14 287.01 170.14 322.25 150.01 322.25 150.01 292.05 129.87 292.05 129.87 322.25 109.74 322.25 109.74 287.01"/>
      <path d="M197.96,313.32c2.3.16,4.61.23,6.95.23,54.15,0,98.36-42.51,101.11-95.97h-107.33v-106.32c-53.01,3.22-95.01,47.22-95.01,101.05,0,7.82.89,15.43,2.56,22.73"/>
      <path d="M222.2,99.63c-1.94,0-3.87.07-5.79.18v98.84h99.79c.08-1.62.13-3.26.13-4.9,0-51.98-42.14-94.12-94.12-94.12Z"/>
    </g>

    <!-- bez inflačnej doložky: prečiarknutý rast ceny (šípka + mince) -->
    <g v-else-if="name === 'inflacia'">
      <circle cx="32" cy="32" r="26"/>
      <path d="M13.6 13.6l36.8 36.8"/>
      <path d="M15 40q3-14 17-20"/>
      <path d="M26 17.5l6 2.5-2.5 6"/>
      <ellipse cx="40" cy="37" rx="9" ry="3.5"/>
      <path d="M31 37v9q0 3.5 9 3.5t9-3.5v-9"/>
      <path d="M31 41.5q0 3.5 9 3.5t9-3.5"/>
    </g>

    <!-- nájom parkingu s opciou kúpy: auto + kalendár -->
    <g v-else-if="name === 'parking'">
      <path d="M13 33l3.5-8.5q1-2.5 3.5-2.5h14q2.5 0 3.5 2.5L41 33"/>
      <rect x="8" y="33" width="38" height="11" rx="3"/>
      <circle cx="15" cy="38.5" r="2"/>
      <circle cx="39" cy="38.5" r="2"/>
      <path d="M22 38.5h10"/>
      <path d="M12 44v4h6v-4M36 44v4h6v-4"/>
      <rect x="43" y="7" width="16" height="16" rx="2"/>
      <path d="M43 12.5h16M47 4.5v4.5M55 4.5v4.5"/>
      <path d="M48.3 12.5V23M53.7 12.5V23M43 17.7h16"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "BenefitIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    // hrúbka čiary v px obrazovky
    stroke: {
      type: [Number, String],
      default: 1.5
    }
  }
}
</script>

<style lang="sass" scoped>
.benefit-icon
  display: inline-block
  width: 100%
  height: 100%
  overflow: visible

  *
    vector-effect: non-scaling-stroke
</style>
